//FUNCTIONS
import React, { useEffect, useState, useCallback } from 'react';
import { StoreState } from '../../store/createStore';
import { useSelector, useDispatch } from 'react-redux';
import { setMessageToast } from '../../store/modules/parameter/actions';
import { changeServicesCheckout } from '../../store/modules/checkout/actions';

//HOOKS
import { useTranslation } from '../../hooks/useTranslation';
//TYPES
import { ServicesProps } from '../../store/modules/product/types';
//COMPONENTS

//STYLES
import {
    ContainerWarranty,
    ContentWarranty,
    ButtonWarranty,
    InfoWarranty,
    TotalsWarranty,
    TitleWarranty,
    ContentGlobal,
    ContentLeft,
    ContentRight
} from './styles';
import { AiFillCheckCircle } from 'react-icons/ai';
import { RoundHelper } from '../../utils/roundHelper';

interface WarrantyProps {
    bReset?: boolean,
    setControlExtern?: boolean,
    itemHasCheckout: boolean,
    productId: string,
    productPrice: number,
    services: ServicesProps[];
    handledSetWarrantySelectedExt: (service: ServicesProps) => void;
    handledSetWarrantyViewInfoModal?: (service: ServicesProps) => void;
}

const Warranty: React.FC<WarrantyProps> = ({
    services,
    handledSetWarrantySelectedExt,
    productPrice,
    productId,
    setControlExtern = false,
    itemHasCheckout = false,
    bReset = false,
    handledSetWarrantyViewInfoModal
}: WarrantyProps) => {
    const dispatch = useDispatch();
    const { onTranslation: t } = useTranslation();
    const { checkout } = useSelector(
        (state: StoreState) => state.checkout,
    );
    const [warrantySelected, setWarrantySelected] = useState<ServicesProps>({
        service_id: -1,
        service_period: 0,
        service_price: '',
    } as ServicesProps);

    const handledSetWarrantySelected = useCallback(async (service: ServicesProps) => {
        if (setControlExtern === true) {
            setWarrantySelected(service);
            handledSetWarrantySelectedExt(service);
        }
        else {
            setWarrantySelected(service);
        }
        if (itemHasCheckout) {
            await dispatch(changeServicesCheckout(productId, service));
            await dispatch(setMessageToast({
                type: 'success', message: t('main.messages_toast.service_change_sucess')
            }));
        }
    }, [handledSetWarrantySelectedExt, setControlExtern, dispatch, itemHasCheckout, t, productId]);

    useEffect(() => {
        if (bReset === true) {
            setWarrantySelected({
                service_id: -1,
                service_period: 0,
                service_price: '',
            } as ServicesProps);
        }
    }, [bReset]);

    useEffect(() => {
        if (checkout.services) {
            checkout.services.map(service => {
                if (service.product_id === productId) {
                    setWarrantySelected(service.service);
                    if (setControlExtern === true) {
                        handledSetWarrantySelectedExt(service.service);
                    }
                }
                return service;
            });
        }
    }, [checkout.services, productId, setControlExtern, handledSetWarrantySelectedExt]);

    return (
        <ContainerWarranty>
            <ContentGlobal>
                <ContentLeft>
                    <TitleWarranty>
                        <span>{t('main.component_warranty.extend_warranty')}</span>
                    </TitleWarranty>
                    <ContentWarranty>
                        <ButtonWarranty
                            onClick={() => handledSetWarrantySelected({ service_id: 0, service_period: 0, service_price: '' } as ServicesProps)}
                        >
                            <div>
                                <span>{t('main.component_warranty.without_extend_warranty')}</span>
                                <span>{RoundHelper.toFormatted('0.00')}</span>
                            </div>
                            <AiFillCheckCircle
                                size="30px"
                                color={warrantySelected.service_id === 0 ? 'green' : '#e2e2e2'} />
                        </ButtonWarranty>
                        {
                            services.map(service => {
                                return (
                                    <ButtonWarranty key={`${service.service_id}-${service.service_period}`}
                                        onClick={() => handledSetWarrantySelected(service)}
                                    >
                                        <div>
                                        <span>{service.service_period} meses</span>
                                        <span>{RoundHelper.toFormatted(service.service_price)}</span>
                                        </div>
                                        <AiFillCheckCircle
                                            size="30px"
                                            color={warrantySelected.service_id === service.service_id
                                                && warrantySelected.service_period === service.service_period ? 'green' : '#e2e2e2'} />
                                    </ButtonWarranty>
                                )
                            })
                        }
                    </ContentWarranty>
                    <InfoWarranty>
                        {
                            warrantySelected.service_id > 0 && <span>{t('main.component_warranty.warranty_info')} <button onClick={() => handledSetWarrantyViewInfoModal && handledSetWarrantyViewInfoModal(warrantySelected)}>{t('main.globals.click_here')}</button></span>
                        }
                    </InfoWarranty>
                </ContentLeft>
                <ContentRight>
                    <TotalsWarranty>
                        <span>{t('main.component_warranty.info_payment')}</span>
                        <div>
                            <span>{t('main.component_warranty.product')}</span>
                            <span>{RoundHelper.toFormatted(productPrice)}</span>
                        </div>
                        <div>
                            <span>{t('main.component_warranty.warranty')}</span>
                            <span>{RoundHelper.toFormatted(warrantySelected.service_price)}</span>
                        </div>

                        <div>
                            <span>{t('main.component_warranty.totals')}</span>
                            <span>{RoundHelper.toFormatted(RoundHelper.toNumber(productPrice) + RoundHelper.toNumber(warrantySelected.service_price))}</span>
                        </div>
                    </TotalsWarranty>
                </ContentRight>
            </ContentGlobal>
        </ContainerWarranty>
    )
}

export default Warranty;